import { CommandRequestType } from "../../authentication/connection/commandRequestType";
import { ICommandResponse } from "../../authentication/connection/iCommandResponse";
import { ErrorDetails } from "../../authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "../../authentication/connection/iRequestCommand";

export class GetAllCarrierCommand extends IRequestCommand<
  IGetAllCarrierResponse,
  ErrorDetails,
  IGetAllCarrierCommandParameters
  > {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl = 'carriers/all?';

  private params = '';

  public override setParameters(parameters: IGetAllCarrierCommandParameters) {
    this.params = (parameters.country) ? this.params + this.getAnd() + "country=" + parameters.country : this.params;
    this.params = (parameters.province) ? this.params + this.getAnd() + "province=" + parameters.province : this.params;
    this._commandUrl = this._commandUrl + this.params;
  }

  getAnd() {
    return (this.params === '') ? '' : '&';
  }

}

export interface IGetAllCarrierCommandParameters {
  country: string;
  province: string
}

export interface IGetAllCarrierResponse extends ICommandResponse {
  id: number
  companyName: string
}